export const formatDate = (date: Date | null): string =>
  date
    ? `${`0${date.getDate().toString()}`.slice(-2)}.${`0${(date.getMonth() + 1).toString()}`.slice(
        -2
      )}.${date.getFullYear()}`
    : '';

export const convertStringToDate = (date?: string): Date | null => {
  if (!date) return null;
  const [day, month, year] = date?.split('.');
  return new Date(Number(year), Number(month) - 1, Number(day));
};

export const formatToISODate = (date?: string): Date => {
  if (!date) return new Date();
  return new Date(date.replace(/^([\d]{2}).([\d]{2}).([\d]{4})$/, '$3-$2-$1'));
};
